import { fetchAPI, METHODS, parseBody } from './common';
import qs from 'qs';

export async function createConnectAccount() {
  const res = await fetchAPI('/stripe/connect/create-account', METHODS.post);
  return await parseBody(res);
}

export async function getConnectAccountStatus() {
  const res = await fetchAPI('/stripe/connect/account-status', METHODS.get);
  return await parseBody(res);
}

export async function getMarketplaceSettings() {
  const res = await fetchAPI('/marketplace/settings', METHODS.get);
  return await parseBody(res);
}

export async function getMarketplacePolicies() {
  const res = await fetchAPI('/marketplace/policies', METHODS.get);
  return await parseBody(res);
}

export async function updateMarketplaceSettings(payload) {
  const res = await fetchAPI('/marketplace/settings', METHODS.put, payload);
  return await parseBody(res);
}

export async function createListing(payload) {
  const res = await fetchAPI('/marketplace/listing', METHODS.post, payload);
  return await parseBody(res);
}

export async function updateListing(id, payload) {
  const res = await fetchAPI(
    `/marketplace/listing/${id}`,
    METHODS.put,
    payload
  );
  return await parseBody(res);
}

export async function deleteListing(id) {
  const res = await fetchAPI(`/marketplace/listing/${id}`, METHODS.delete);
  return await parseBody(res);
}

export async function getListingById(id) {
  const res = await fetchAPI(`/marketplace/listing/${id}`, METHODS.get);
  return await parseBody(res);
}

export async function getListingOrders(id, params = {}) {
  const res = await fetchAPI(
    `/marketplace/listing/${id}/orders?${qs.stringify(params)}`,
    METHODS.get
  );
  return await parseBody(res);
}

export async function purchaseListing(id, payload = {}) {
  const res = await fetchAPI(
    `/marketplace/listing/${id}/purchase`,
    METHODS.post,
    payload
  );
  return await parseBody(res);
}

export async function releaseOrder(id, payload = {}) {
  const res = await fetchAPI(
    `/marketplace/orders/${id}/release`,
    METHODS.post,
    payload
  );
  return await parseBody(res);
}

export async function adjustOrder(id, payload) {
  const res = await fetchAPI(
    `/marketplace/orders/${id}/adjustment`,
    METHODS.post,
    payload
  );
  return await parseBody(res);
}

export async function rescheduleOrder(orderId, payload) {
  const res = await fetchAPI(
    `/marketplace/orders/${orderId}/schedule`,
    METHODS.put,
    payload
  );
  return await parseBody(res);
}

export async function updateOrderFulfillment(id, payload) {
  const res = await fetchAPI(
    `/marketplace/orders/${id}/fulfillment`,
    METHODS.put,
    payload
  );
  return await parseBody(res);
}

export async function browseListings(params = {}) {
  const res = await fetchAPI(
    `/marketplace/listings/browse?${qs.stringify(params, {
      arrayFormat: 'repeat',
    })}`,
    METHODS.get
  );
  return await parseBody(res);
}

export async function getMyListings(params = {}) {
  const res = await fetchAPI(
    `/marketplace/listings/me?${qs.stringify(params)}`,
    METHODS.get
  );
  return await parseBody(res);
}

export async function getMyOrders(params = {}) {
  const res = await fetchAPI(
    `/marketplace/orders/me?${qs.stringify(params)}`,
    METHODS.get
  );
  return await parseBody(res);
}

export async function getIncomingOrders(params = {}) {
  const res = await fetchAPI(
    `/marketplace/orders/incoming?${qs.stringify(params)}`,
    METHODS.get
  );
  return await parseBody(res);
}

export async function getOrder(id) {
  const res = await fetchAPI(`/marketplace/orders/${id}`, METHODS.get);
  return await parseBody(res);
}

export async function createOrderIssue(orderId, payload) {
  const res = await fetchAPI(
    `/marketplace/orders/${orderId}/issues`,
    METHODS.post,
    payload
  );
  return await parseBody(res);
}

export async function getOrderIssues(orderId) {
  const res = await fetchAPI(
    `/marketplace/orders/${orderId}/issues`,
    METHODS.get
  );
  return await parseBody(res);
}

export async function createOrderReview(orderId, payload) {
  const res = await fetchAPI(
    `/marketplace/orders/${orderId}/reviews`,
    METHODS.post,
    payload
  );
  return await parseBody(res);
}

export async function getOrderReviews(orderId) {
  const res = await fetchAPI(
    `/marketplace/orders/${orderId}/reviews`,
    METHODS.get
  );
  return await parseBody(res);
}

export async function getTeamRating(teamId) {
  const res = await fetchAPI(
    `/marketplace/teams/${teamId}/rating`,
    METHODS.get
  );
  return await parseBody(res);
}

export async function getMarketplaceEligibility() {
  const res = await fetchAPI('/marketplace/eligibility', METHODS.get);
  return await parseBody(res);
}

export async function registerStateInterest(payload = {}) {
  const res = await fetchAPI(
    '/marketplace/state-interest',
    METHODS.post,
    payload
  );
  return await parseBody(res);
}

export async function requestSellerAccess(payload = {}) {
  const res = await fetchAPI(
    '/marketplace/seller/request',
    METHODS.post,
    payload
  );
  return await parseBody(res);
}

// ----- Org-level saved payment methods (platform Stripe customer) -----------

export async function createPaymentMethodSetup() {
  const res = await fetchAPI(
    '/marketplace/payment-methods/setup',
    METHODS.post
  );
  return await parseBody(res);
}

export async function getSavedPaymentMethods() {
  const res = await fetchAPI('/marketplace/payment-methods', METHODS.get);
  return await parseBody(res);
}

export async function confirmSavedPaymentMethod(paymentMethodId) {
  const res = await fetchAPI(
    '/marketplace/payment-methods/confirm',
    METHODS.post,
    { payment_method_id: paymentMethodId }
  );
  return await parseBody(res);
}

export async function deleteSavedPaymentMethod(id) {
  const res = await fetchAPI(
    `/marketplace/payment-methods/${id}`,
    METHODS.delete
  );
  return await parseBody(res);
}

export async function downloadOrderReceipt(orderId) {
  const res = await fetchAPI(
    `/marketplace/orders/${orderId}/receipt`,
    METHODS.get
  );

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || 'Failed to download receipt');
  }

  return await res.blob();
}
